import { createActionConst } from '../../../utils/action.utils';

const COLUMN_NAMESPACE = 'COLUMN';

export const STORE_COLUMN = createActionConst(COLUMN_NAMESPACE, 'STORE_COLUMN');
export const CLEAR_COLUMN = createActionConst(COLUMN_NAMESPACE, 'CLEAR_COLUMN');
